import React from 'react'
import ChangeIdentityContainer from 'modules/auth/changeIdentity/ChangeIdentityContainer'
import ChangeIdentityView from 'modules/auth/changeIdentity/ChangeIdentityView'

const ChangeIdentityPage = () => {
	return <ChangeIdentityContainer>{ChangeIdentityView}</ChangeIdentityContainer>
}

export default ChangeIdentityPage
